import 'css-chunksrc/client/pages/projectPage/navigation/styles.scss';export default {
  "navigation": "_navigation_16nab_1",
  "item": "_item_16nab_8",
  "selectedItem": "_selectedItem_16nab_15",
  "icon": "_icon_16nab_19",
  "selectedLink": "_selectedLink_16nab_21",
  "text": "_text_16nab_26",
  "link": "_link_16nab_33",
  "timeSheets": "_timeSheets_16nab_62"
};